import Vue from "vue";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
Vue.use(VuePersianDatetimePicker, {
  name: "date-picker",
  props: {
    inputFormat: "jYYYY-jMM-jDD HH:mm:ss",
    format: "jYYYY-jMM-jDD HH:mm:ss",
    editable: true,
    inputClass: "form-control my-custom-class-name",
    altFormat: "YYYY-MM-DD HH:mm:ss",
    color: "#9e95f5",
    autoSubmit: false,
    //...
    //... And whatever you want to set as default
    //...
  },
});
